import { Address, JavaContactAddress } from './address.model';

export enum ContactType {
    CONTACT,
    LEAD
}

export enum ContactStatus {
    ACTIVE = 1,
    UNCONFIRMED = 2,
    INACTIVE = 3,
    DELETED = 4
}

export class Contact {
    public account: ContactAccount;
    public mobile: string;
    public organisation: { id: number; name: string };
    public contactId: number;
    public inUse: boolean;
    public portalTcAccepted: boolean;
    constructor(public contactType: number,
        public contactStatus: ContactStatus,
        public isStaff: boolean,
        public firstName: string,
        public lastName: string,
        public phone: string,
        public email: string,
        public hideMyOrders: boolean,
        public postalAddress: Address,
        public deliveryAddress: Address) {
    }
}

export class JavaContact {
    public account: ContactAccount;
    public mobile: string;
    public organisation: { id: number; name: string };
    public contactId: number;
    public inUse: boolean;
    public portalTcAccepted: boolean;
    constructor(public contactType: number,
        public firstName: string,
        public lastName: string,
        public phone: string,
        public email: string,
        public hideMyOrders: boolean,
        public postalAddress: JavaContactAddress,
        public deliveryAddress: JavaContactAddress) {
    }
}

export interface ContactMapping {
    authorisationId: string;
}

export interface ContactAccount {
    id: number;
    name: string;
}

export class ContactRegistration {
    constructor(public firstName: string,
        public lastName: string,
        public email: string,
        public company: string,
        public mobilePhone: string,
        public homePhone: string,
        public password: string,
        public physicalAddress: Address,
        public postalAddress: Address,
        public portalTcAccepted: boolean) {
    }
}
